// extracted by mini-css-extract-plugin
export default {"wrapper":"LottieWrapper_wrapper__kBK+9","lotties":"LottieWrapper_lotties__SmHyd","selector":"LottieWrapper_selector__1K0vB"};